<div mat-dialog-title>
  {{ (data?.title ?? 'Select from the following') | translate:locale.language }}
</div>
<div mat-dialog-content>
  <mat-selection-list (selectionChange)="change($event)" [multiple]="true">
    @for (item of data.items; track $index) {
      <mat-list-option [selected]="isSelected(item)" [value]="item">
        {{ item.display }}
      </mat-list-option>
    }
  </mat-selection-list>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onClose('cancel')">{{ 'Cancel' | translate: locale.language }}</button>
  <button mat-stroked-button color="accent" (click)="onClose('reset')">
    {{ 'Reset' | translate: locale.language }}
  </button>
  <button mat-raised-button color="primary" (click)="onClose('select')">
    {{ 'Select' | translate: locale.language }} ({{ result.length }})
  </button>
</div>
